import { useNostr } from '@nostrify/react';
import { useInfiniteQuery } from '@tanstack/react-query';
import type { NostrEvent } from '@nostrify/nostrify';

/** Hook that fetches kind 1 notes tagged #bitcoin with infinite scroll pagination. */
export function useBitcoinFeed() {
  const { nostr } = useNostr();

  return useInfiniteQuery<NostrEvent[]>({
    queryKey: ['bitcoin-feed'],
    queryFn: async ({ pageParam, signal }) => {
      const filter: Record<string, unknown> = { kinds: [1], '#t': ['bitcoin'], limit: 20 };
      if (pageParam) filter.until = pageParam;

      const events = await nostr.query([filter], {
        signal: signal ?? AbortSignal.timeout(3000),
      });

      // Sort newest first within each page
      return events.sort((a, b) => b.created_at - a.created_at);
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.length === 0) return undefined;
      // Subtract 1 since 'until' is inclusive
      return lastPage[lastPage.length - 1].created_at - 1;
    },
    initialPageParam: undefined as number | undefined,
  });
}
